/* eslint-disable array-callback-return, default-case  */

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import BreakdownHeading from './components/BreakdownHeading';
import ChargesLineItem from 'components/ChargesLineItem';
import CreditCardLineItem from './components/CreditCardLineItem';
import CreditNoteLineItem from './components/CreditNoteLineItem';
import PointsLineItem from './components/PointsLineItem';
import QantasTravelPassLineItem from './components/QantasTravelPassLineItem';
import VoucherLineItem from './components/VoucherLineItem';
import * as propTypes from './propTypes';

const RefundBreakdown = ({ breakdown, penalty, showHeading, titleStyle, itemStyle }) => (
  <Fragment>
    {showHeading && <BreakdownHeading>REFUND</BreakdownHeading>}
    {breakdown.map((breakdownItem) => {
      const { method } = breakdownItem;
      switch (method) {
        case 'credit_card':
          return <CreditCardLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
        case 'voucher':
          return <VoucherLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
        case 'points':
          return <PointsLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
        case 'credit_note':
          return <CreditNoteLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
        case 'qantas_group_credit_voucher':
          return <QantasTravelPassLineItem key={method} {...breakdownItem} titleStyle={titleStyle} itemStyle={itemStyle} />;
      }
    })}

    {penalty.length > 0 && (
      <Fragment>
        <BreakdownHeading mt={4}>CHARGES</BreakdownHeading>
        <ChargesLineItem penalty={penalty} />
      </Fragment>
    )}
  </Fragment>
);

RefundBreakdown.defaultProps = {
  showHeading: true,
  titleStyle: {},
  itemStyle: {},
};

RefundBreakdown.propTypes = {
  showHeading: PropTypes.bool,
  breakdown: PropTypes.arrayOf(propTypes.paymentBreakdownItem).isRequired,
  penalty: ChargesLineItem.propTypes.penalty,
  titleStyle: PropTypes.object,
  itemStyle: PropTypes.object,
};

export default RefundBreakdown;
